<template>
  <div id="app">
    <div class="scroll-container" :class="{ 'disable-snap': isSnapDisable }">
      <div
        class="scroll-area landing"
        v-observe-visibility="{
          callback: landingVisibilityChanged,
          intersection: {
            threshold: 0.3,
          },
        }"
      >
        <Landing />
      </div>
      <div class="scroll-area">
        <Layout
          :sections="wording.sections"
          :nowSection="nowSection"
          :shouldShowLayout="shouldShowLayout"
        >
          <MainContent
            :conclusions="wording.conclusions"
            :sot="wording.sot"
            :feedbacks="wording.feedbacks"
            :action="wording.action"
            :actionTwo="wording.actionTwo"
            @setNowSection="setNowSection"
            @setDisableSnap="setDisableSnap"
          />
        </Layout>
      </div>
    </div>
  </div>
</template>

<script>
import Landing from "./components/Landing.vue";
import Layout from "./components/Layout.vue";
import MainContent from "./components/MainContent.vue";

export default {
  name: "App",
  components: {
    Landing,
    Layout,
    MainContent,
  },
  data() {
    return {
      isSnapDisable: false,
      nowSection: [1, 1],
      shouldShowLayout: false,
      windowWidth: window.innerWidth,
      wording: {
        sections: [
          {
            name: ["最強職人", "養護愛車調查大公開"],
            parts: [
              "汽車保養廠的選擇關鍵",
              "完美保養必備要件",
              "最重視的零件品質",
              "最在意的服務細節",
            ],
          },
          {
            name: ["米其林認證保養", "體驗心得大直擊"],
            parts: [
              "「頂尖對決」滿意度大挑戰",
              "車主體驗真心話",
              "網友好評回饋",
            ],
          },
        ],
        conclusions: [
          {
            title: "挑選專業保養廠的<br class='mobile'/>主要關鍵？",
            subtitle: "價格透明是關鍵",
            content: [
              "<b>88.5%</b>車主認為<b>價格透明</b>為挑選汽車專業保養廠的主要關鍵。在保養過程中，車主除了在意價格透明、售後服務外，<b>維修技術</b>更佔了86.7%的比例。此外有車主表示，在過去曾遇到比自己懂得還少的技師，讓他在來回溝通裡漸失去對保養廠的信任。",
              "馳加始終堅持在客戶沒有清楚了解車輛狀況及所需費用下，不會擅自施工，同時在<b>輪胎</b>、<b>機油</b>及<b>制動系統</b>三大核心業務上，更是以扎實流程、精湛技術獲得廣大消費者一致認可。",
            ],
            graph: 1,
          },
          {
            title: "是否會期待技師的維修、<br/>保養技術與保護細節？",
            subtitle: "專業維修保養好安心",
            content: [
              "問卷調查顯示，<b>41%</b>車主認為在汽車保養過程中若能以<b>專業儀器輔助</b>，更能讓人安心。",
              "馳加店家除了備有專業儀器輔助，讓技師更能全面掌握整個車子狀況外；在檢查過程中也會盡可能<b>保護</b>車輛、確認細節，以提供車主值得信任的服務體驗。",
            ],
            graph: 2,
          },
          {
            title:
              "對於汽車保養更換的零件，<br/>你會擔心零件是否為原廠或質量問題嗎？",
            subtitle: "原廠零件品質有保障",
            content: [
              "問卷調查顯示：<b>85%</b>車主擔心保養維修時，保養廠<b>提供非原廠、品質不佳</b>之零件。其中也有車主表示曾擅自被更換二手零件，卻在最後才被通知要收取費用。",
              "馳加在保養過程中，會不斷與車主確認報價，所供應之零部件均為可信賴之國際品牌：如MICHELIN米其林輪胎、TOTAL道達爾潤滑油、BOSCH博世煞車零配件等，除確保商品的品質與穩定外，更保障車主的行車體驗與安全。",
            ],
            graph: 3,
          },
          {
            title: "會在意技師/接待員的<br class='mobile'/>服務態度嗎？",
            subtitle: "服務至上是關鍵",
            content: [
              "調查中顯示，<b>98%</b>的車主對於<b>汽車保養的消費體驗</b>是注重的，在消費者越來越重視消費體驗與滿意度下，汽車快保已非過往傳統黑手形象，馳加除了優質的技術專業度外，從店內環境、接待流程到報價流程，都希望帶給消費者不同於傳統且更貼近於原廠的體驗過程。",
            ],
            graph: 4,
          },
        ],
        sot: {
          vidoeId: "B9vR5AvGiSI",
          title: ["直擊！米其林認證保養體驗！", "最狂愛車魔人是他！"],
          desc: "近期馳加針對最呵護愛車、以車為業的多元計程車司機們進行問卷調查。在過程中，我們發現大多數司機最在意：專業技術、透明的價格，與良好的售後服務等三大重點。因此，我們這次邀請這些愛車司機們來馳加店裡實際體驗保養與換胎服務。究竟馳加的專業技師們如何提供米其林認證的高品質服務？而這些司機們到最後是否滿意呢？",
        },
        feedbacks: [
          {
            name: "陳欽輝",
            isMr: true,
            store: "一品三重店",
            desc: [
              "這是我第一次到馳加，發現店家非常明亮乾淨，因為剛好遇到下雨，我車才剛開到，接待人員馬上打傘出來接我，服務超好！檢查前還會細心的套上保護套，檢查過程中有什麼問題也都會一一說明，並提供清楚的報價單，技師也不會強迫一定要換，完全尊重我的想法。這次經驗有別於之前去過的保養廠，所以我問了很多問題，尤其是四輪定位，第一次看到這麼精密的器材非常好奇，技師也都親切且專業的回答我，能多認識一間可信賴的保養廠真開心。",
            ],
            imgGroupId: 1,
          },
          {
            name: "童閔浩",
            isMr: true,
            store: "穩路林口店",
            desc: [
              "這次馳加保養和換胎體驗跟我以前自己去的車廠有很大的不同，全車健檢時技師非常細心，換機油的時候還會把引擎裝保護罩，不用擔心車被弄髒。以前換輪胎其它車廠做輪胎平衡都不會幫車主把輪框特別擦乾淨，這次看到他們一個一個輪框認真擦，定位時也覺得他們真的非常細心！",
              "技師也很專業，全車健檢時幫我檢查出漏油，我前陣子才去檢查車子，當時完全沒有檢查出來！還有我沒想過保養廠的休息室可以做的這麼精緻舒服，這點也大加分！",
            ],
            imgGroupId: 2,
          },
          {
            name: "彭博皓",
            isMr: true,
            store: "建凱店",
            desc: [
              "我本身是米其林輪胎的愛用者，之前就去過馳加其它分店做過輪胎定位，雖然很多車廠有類似服務，但靠機器定位完，技師還要開上路試車確認，這就非常考驗技師的真功夫，專業的技師就會讓人覺得安心。",
              "馳加讓我驚豔的是，我今天體驗的這間店素質也很好，要能連鎖又品質穩定真的不容易，會讓我覺得如果我以後在不同縣市遇到問題，就可以放心到當地馳加，加上他們價目表在牆上一目了然，也不用擔心說在異地亂找保養廠被坑錢。",
            ],
            imgGroupId: 3,
          },
          {
            name: "陳正弘",
            isMr: true,
            store: "利馨店",
            desc: [
              "這次體驗我很期待，我原本輪胎也是有廠牌的，但連乘客都反應輪胎聲音很大，聽說米其林輪胎安靜、好用，等不及想要用看看！以前我都是交給一般保養廠用車，這次發現米其林認證的保養果然不一樣，像四輪定位，店家說他們最近才進了最新的機器，景氣不好還這樣投資，真的很用心！",
              "我們營業車很注重用在車子上的每一分錢，技師提供的報價一目了然，講解過程也都把選擇權交在我們手上，不會覺得壓力很大，整體感受起來真的滿舒服的！",
            ],
            imgGroupId: 4,
          },
          {
            name: "黃海華",
            isMr: false,
            store: "新洲店",
            desc: [
              "這次體驗我最喜歡的是環境很舒服乾淨，重要的是坐在休息室就可以看到車子保養的狀況，一般我都是回原廠保養，原廠車一開走什麼就看不到，就發生過保養完車有問題的爭議，可以直接看到技師做什麼，感覺很安心，而且服務態度也很親切。",
              "我覺得既然買了油電車，就要多了解它，我甚至自己也都是買機油去原廠換，這次體驗用的機油是不錯的品牌，加上搭配米其林輪胎，都是可信任的大品牌，會讓我覺得原廠之外也多了一個新的選擇！",
            ],
            imgGroupId: 5,
          },
          {
            name: "黃泰源",
            isMr: true,
            store: "灃興和平店",
            desc: [
              "以前在原廠保養不但費用高，還會試著說服我提早更換零件，感受很不好，後來就在外廠居多。這次體驗覺得馳加的環境很舒服，不輸原廠，而且服務很親切，不會有冷冰冰很制式的感覺。技師說明報價也都非常清楚，沒有強迫更換的壓力，也會很實在的講解車子狀況，有一種「是為了車子好」的感覺，讓人很安心。",
              "這次讓我印象特別深刻的是在裝輪胎時用了扭力板手，問了技師才知道這種方式才是正確的，除了體驗還學到新知識，真的很棒。",
            ],
            imgGroupId: 6,
          },
          {
            name: "張亦杰",
            isMr: true,
            store: "百世霸店",
            desc: [
              "我很要求自己營業車的保養照護，我5000km就回原廠保養一次，大概一個月一次的頻率，這次到馳加體驗，發現服務接待和環境跟原廠有的比，而且我第一次換輪胎看到有保養廠會這樣擦輪框，外面很少人這麼細心的啦！這一點我真的非常驚豔！",
              "還有整個過程中技師邊做我邊發問，也都很專業回答，不會覺得客人站在旁邊很干擾工作就不耐煩，這也非常加分！第一次來馳加體驗，整體感受這麼好，之後也會考慮到馳加繼續保養。",
            ],
            imgGroupId: 7,
          },
          {
            name: "鄭天來",
            isMr: true,
            store: "穩路林口店",
            desc: [
              "跑車這麼久，我挑保養廠最在意細心和專業，再來是輪胎挑選上要能安靜夠穩，畢竟乘客坐的舒適才會給我五顆星啊！這次體驗技師查車時，找到一些狀況，他很仔細地跟我解說，建議我可以怎麼解決、費用多少，讓我覺得很安心。",
              "從服務人員到技師都很親切也很有耐心，尤其是報價清楚，今天做什麼、多少錢，價格都在這，相當沒有壓力，覺得他們是為了車子好，不是想框錢。今天保養，我在休息室邊喝咖啡舒服地等待，時間過很快，體驗很好。",
            ],
            imgGroupId: 8,
          },
          {
            name: "楊旭淵",
            isMr: true,
            store: "利馨店",
            desc: [
              "我保養頻率高，耗材更換也頻繁，所以保養廠的專業和物有所值是我最在意的，不要為了省一點錢犧牲品質。這次體驗馳加四輪定位服務覺得非常專業，除了機器定位，技師還會去試跑確認，這點就讓人安心。 雖然是第一次來馳加，技師也都沒把我當過路客一樣打發，非常親切！像剛剛車子快保養好，技師還會提醒說要記得5000公里來調胎，這樣對車比較好。我們常在用車，這些道理我們都懂，但馳加主動提醒就會覺得店家很細心，值得再來。",
            ],
            imgGroupId: 9,
          },
          {
            name: "黃資城",
            isMr: true,
            store: "安勇新北店",
            desc: [
              "我是技師出身，除了因營業車保養頻繁外，對車本身就很熟悉，這次體驗的米其林輪胎也是我一直在用的，我常跟朋友說，去計較輪胎本身價格沒用，像這條胎節能，省下來的油錢搞不好算下來輪胎是免費咧！",
              "馳加整體環境和服務很棒，店內用的其它耗材也都是大品牌，像Total機油、BOSCH耗材等等，讓人很安心。價格也很透明，一進休息室上面什麼項目多少錢都很清楚，報價單也是這樣，沒有落差，是可以信賴的保養廠，非常推薦！",
            ],
            imgGroupId: 10,
          },
        ],
        action: {
          title: "網友好評回饋  現正蒐集中",
          desc: "法國米其林集團旗下品牌「TYREPLUS馳加」，因專業的汽車保養技術、高品質售後服務與價格透明，讓消費者享有優質的汽車保養體驗。現今在網路上已累積一大票死忠粉絲！看完「頂尖對決」車主們的實際保養與體驗心得後，究竟網友會怎麼說？敬請期待！",
        },
        actionTwo: {
          title: "網友好評回饋大公開",
          desc: "法國米其林集團旗下品牌「TYREPLUS馳加」，因價格透明、專業的汽車保養技術，與高品質售後服務，讓消費者享有國際水準的汽車保養體驗。現今在網路上已累積一大票死忠粉絲！看完「頂尖對決」車主們的實際保養與體驗心得後，現在快來瞧瞧網友怎麼說吧！",
        },
      },
    };
  },
  methods: {
    setNowSection(sectionArr) {
      this.nowSection = sectionArr;
    },
    landingVisibilityChanged(visibility) {
      if (this.windowWidth < 768) {
        this.shouldShowLayout = true;
      } else {
        this.shouldShowLayout = !visibility;
      }
    },
    setDisableSnap(value) {
      this.isSnapDisable = value;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth < 768) {
        this.shouldShowLayout = true;
      }
    },
  },
  mounted() {
    this.$ga.page("/campaigns/tyreplus2022");
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="scss" scoped>
@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);
#app {
  font-family: "Noto Sans TC";
  margin: 0;

  .scroll-container,
  .scroll-area {
    max-width: 100vw;
    height: 100vh;
  }

  .scroll-container {
    overflow: auto;
    scroll-snap-type: y mandatory;
  }

  .scroll-area {
    scroll-snap-align: start;
    position: relative;
  }

  .landing {
    height: 205vw;
    @media (min-width: 768px) {
      height: 66.46vw;
      min-height: 100vh;
    }
  }
}
</style>
